import { useIsAuthenticated } from '@cretesuite/api-client-auth/src/hooks/useIsAuthenticated'
import { useCreation } from 'ahooks'
import type React from 'react'
import { Provider } from 'urql'
import { useAccessTokenActions } from '../../hooks/useAccessToken'
import { useTraceRequest } from '../../hooks/useTraceRequest'
import { useGraphQLCache } from './Cache'
import { createGraphQLClient } from './createGraphQLClient'

export const GraphQLProvider = ({ children }: React.PropsWithChildren) => {
  const { cache: cacheStorage } = useGraphQLCache()
  const accessTokenActions = useAccessTokenActions()
  const isAuthenticated = useIsAuthenticated()
  const traceRequestActions = useTraceRequest()

  const client = useCreation(
    () =>
      createGraphQLClient({
        cacheStorage,
        accessTokenActions,
        traceRequestActions,
      }),
    [cacheStorage, accessTokenActions, isAuthenticated, traceRequestActions],
  )
  return <Provider value={client}>{children}</Provider>
}
